
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div id=\"vertical_present_box\" class=\"vertical_present_box\">\n    <div class=\"select_box\">\n        <div class=\"container\">\n        ")
    ;  for(var i = 0; i < data.length; i++) {
    ; __append("\n            <div class=\"item bdr-r\" data-id=\"")
    ; __append(escape(data[i].id))
    ; __append("\">\n                <span class=\"item-icon\"></span>\n                <div class=\"item-img\" style=\"background-image: url(")
    ; __append(escape(data[i].pic))
    ; __append(")\">\n                    <!-- <img src=\"../images/1.png\"> -->\n                </div>\n                <div class=\"item-name\">")
    ; __append(escape(data[i].name))
    ; __append("</div>\n                <div class=\"item-info\">\n                ")
    ;  if(data[i].type == 'countdown') { 
    ; __append("\n                    <span>")
    ; __append(escape(data[i].countdown))
    ; __append("</span>秒\n                ")
    ;  } else { 
    ; __append("\n                    <span>")
    ; __append(escape(data[i].price))
    ; __append("</span>币\n                ")
    ;  } 
    ; __append("\n                </div>\n            </div>\n        ")
    ;  } 
    ; __append("\n        </div>\n        <div class=\"bar\">\n            <div class=\"money\">\n                余额: <span class=\"num\">")
    ; __append(escape(coin))
    ; __append("</span>金币\n                <span class=\"icon\"></span>\n            </div>\n            <div class=\"btn js_btn\">发送</div>\n        </div>\n    </div>\n</div>")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/modules/f.component.gift.mobile/app/lib/verticalPresent/verticalPresent.ejs
// module id = 127
// module chunks = 0